import { Plus, Trash2 } from "lucide-react";
import { Button, Select } from "@marekl/adminer/components";
import styles from "./CertificatesPage.module.css";

export interface ItemDraft {
  kind: "voucher" | "merch";
  product_name: string;
  product_code: string;
  voucher_type_id: string;
  merch_kind_id: string;
}

const EMPTY_ITEM: ItemDraft = {
  kind: "voucher",
  product_name: "",
  product_code: "",
  voucher_type_id: "",
  merch_kind_id: "",
};

interface ItemsEditorProps {
  items: ItemDraft[];
  onChange: (items: ItemDraft[]) => void;
  voucherTypes: { id: number; name: string; active: boolean }[];
  merchKinds: { id: number; name: string; active: boolean }[];
}

export function ItemsEditor({ items, onChange, voucherTypes, merchKinds }: ItemsEditorProps) {
  function updateItem(i: number, patch: Partial<ItemDraft>) {
    onChange(items.map((it, idx) => (idx === i ? { ...it, ...patch } : it)));
  }
  function removeItem(i: number) {
    onChange(items.filter((_, idx) => idx !== i));
  }
  function addItem() {
    onChange([...items, { ...EMPTY_ITEM }]);
  }

  return (
    <div className={styles.itemsEditor}>
      {items.map((item, i) => (
        <div key={i} className={styles.itemDraft}>
          <div className={styles.itemDraftRow}>
            <Select
              label="Druh"
              value={item.kind}
              onChange={(e) => updateItem(i, { kind: e.target.value as "voucher" | "merch", voucher_type_id: "", merch_kind_id: "" })}
            >
              <option value="voucher">Voucher</option>
              <option value="merch">Merch</option>
            </Select>

            {item.kind === "voucher" ? (
              <Select
                label="Typ voucheru"
                value={item.voucher_type_id}
                onChange={(e) => updateItem(i, { voucher_type_id: e.target.value, product_name: voucherTypes.find((v) => String(v.id) === e.target.value)?.name ?? item.product_name })}
                className={styles.itemWide}
              >
                <option value="">— vyberte typ —</option>
                {voucherTypes.filter((v) => v.active).map((v) => (
                  <option key={v.id} value={v.id}>{v.name}</option>
                ))}
              </Select>
            ) : (
              <Select
                label="Produkt"
                value={item.merch_kind_id}
                onChange={(e) => updateItem(i, { merch_kind_id: e.target.value, product_name: merchKinds.find((m) => String(m.id) === e.target.value)?.name ?? item.product_name })}
                className={styles.itemWide}
              >
                <option value="">— vyberte produkt —</option>
                {merchKinds.filter((m) => m.active).map((m) => (
                  <option key={m.id} value={m.id}>{m.name}</option>
                ))}
              </Select>
            )}

            <button
              type="button"
              className={styles.removeBtn}
              onClick={() => removeItem(i)}
              aria-label="Odstranit položku"
            >
              <Trash2 size={15} />
            </button>
          </div>
        </div>
      ))}

      <Button variant="ghost" size="sm" onClick={addItem} type="button">
        <Plus size={14} /> Přidat položku
      </Button>
    </div>
  );
}
